import { FC, SVGProps } from 'react';

const BroadcastGroupIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 24,
  color = '#3D906D',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.15967 19.5634C8.26467 19.5634 7.72384 18.9195 7.68555 18.0227C7.68555 16.1973 9.46758 15.5676 12.1526 15.5464C14.8424 15.5747 16.6292 16.2044 16.6196 18.0227C16.5765 18.9195 16.0389 19.5634 15.1455 19.5634H9.15967Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.1533 13.2319C13.4429 13.2319 14.4883 12.1865 14.4883 10.897C14.4883 9.60741 13.4429 8.56201 12.1533 8.56201C10.8637 8.56201 9.81836 9.60741 9.81836 10.897C9.81836 12.1865 10.8637 13.2319 12.1533 13.2319Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M6.70915 10.8823C4.47969 10.8999 3 11.4228 3 12.9385C3.03179 13.6832 3.48086 14.2178 4.22402 14.2178H7.11119"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2907 10.8823C19.5202 10.8999 20.9999 11.4228 20.9999 12.9385C20.9681 13.6832 20.519 14.2178 19.7759 14.2178H16.8887"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.44467 8.31462C7.51544 8.31462 8.38347 7.44659 8.38347 6.37582C8.38347 5.30504 7.51544 4.43701 6.44467 4.43701C5.37389 4.43701 4.50586 5.30504 4.50586 6.37582C4.50586 7.44659 5.37389 8.31462 6.44467 8.31462Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M17.555 8.31462C16.4842 8.31462 15.6162 7.44659 15.6162 6.37582C15.6162 5.30504 16.4842 4.43701 17.555 4.43701C18.6258 4.43701 19.4938 5.30504 19.4938 6.37582C19.4938 7.44659 18.6258 8.31462 17.555 8.31462Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default BroadcastGroupIcon;
